<script setup></script>

<template>
    <v-app>
        <slot></slot>
    </v-app>
</template>

<style scoped></style>
